RivalIQ.module('export.models.factories', function (factories, App, Backbone, Marionette, $, _) {

    'use strict';

    factories.pdf = function (model) {
        const slides = [
            model.getExportPage()
        ];

        let props = model.config.getProps();
        props = _.pick(props, 'landscapeId', 'companySetDescriptor', 'timePeriod', 'activeSources', 'focusCompanyId');

        const attrs = _.extend({
            branding: RivalIQ.state.view.getActiveBranding().toJSON(),
            activeBranding: RivalIQ.utils.branding.getActiveBrandingType(),
            orientation: model.getOrientation(),
            width: model.config.getExportWidth(RivalIQ.enums.exportFormat.PDF),
            usePostPhantomMargin: model.config.getUsePdfPostMargin(),
            slides: slides
        }, props);

        model.set(attrs, {
            silent: true
        });
    };
});
